var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.getPagesRange.length > 0,
          expression: "getPagesRange.length > 0",
        },
      ],
      attrs: { "aria-label": "Pagination" },
    },
    [
      _c(
        "ul",
        { staticClass: "pagination text-center" },
        [
          _vm.showControls
            ? [
                _vm.isFirstPage
                  ? _c("li", { staticClass: "pagination-first disabled" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("table.page.first")))]),
                    ])
                  : _c("li", { staticClass: "pagination-first" }, [
                      _c(
                        "button",
                        {
                          attrs: {
                            role: "button",
                            title: _vm.$t("table.page.first"),
                          },
                          on: { click: _vm.onClickFirstPage },
                        },
                        [_vm._v(_vm._s(_vm.$t("table.page.first")))]
                      ),
                    ]),
                _vm._v(" "),
                _vm.isFirstPage
                  ? _c("li", { staticClass: "pagination-previous disabled" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("table.page.prev")))]),
                    ])
                  : _c("li", { staticClass: "pagination-previous" }, [
                      _c(
                        "button",
                        {
                          attrs: {
                            role: "button",
                            title: _vm.$t("table.page.prev"),
                          },
                          on: { click: _vm.onClickPrevPage },
                        },
                        [_vm._v(_vm._s(_vm.$t("table.page.prev")))]
                      ),
                    ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getPagesRange, function (page) {
            return [
              page.isActive
                ? _c("li", { staticClass: "pagination-page current" }, [
                    _c("span", [_vm._v(_vm._s(page.key))]),
                  ])
                : _c("li", { staticClass: "pagination-page" }, [
                    _c(
                      "button",
                      {
                        attrs: {
                          role: "button",
                          title: page.key,
                          disabled: page.isDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickPage(page.key)
                          },
                        },
                      },
                      [_vm._v(_vm._s(page.key))]
                    ),
                  ]),
            ]
          }),
          _vm._v(" "),
          _vm.showControls
            ? [
                _vm.isLastPage
                  ? _c("li", { staticClass: "pagination-next disabled" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("table.page.next")))]),
                    ])
                  : _c("li", { staticClass: "pagination-next" }, [
                      _c(
                        "button",
                        {
                          attrs: {
                            role: "button",
                            title: _vm.$t("table.page.next"),
                          },
                          on: { click: _vm.onClickNextPage },
                        },
                        [_vm._v(_vm._s(_vm.$t("table.page.next")))]
                      ),
                    ]),
                _vm._v(" "),
                _vm.isLastPage
                  ? _c("li", { staticClass: "pagination-last disabled" }, [
                      _c("span", [_vm._v(_vm._s(_vm.$t("table.page.last")))]),
                    ])
                  : _c("li", { staticClass: "pagination-last" }, [
                      _c(
                        "button",
                        {
                          attrs: {
                            role: "button",
                            title: _vm.$t("table.page.last"),
                          },
                          on: { click: _vm.onClickLastPage },
                        },
                        [_vm._v(_vm._s(_vm.$t("table.page.last")))]
                      ),
                    ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }